



























































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import * as Reveal from '@/assets/scripts/RevealOnScrollModule';
import Swiper from 'swiper';

@Component
export default class SwiperContentSlider extends Vue {

	data() {
		return {
			PageTitle: "Swiper content slider"
		}
	}
	mounted() {
		new Reveal.revealOnScrollModule();

		// init swiper
		let slideContainer = '[data-swiper-container]';
		let swiper = new Swiper(slideContainer, {
			slidesPerView: 'auto',
			freeMode: true,
			observer: true,
			observeParents: true,
			scrollbar: {
				el: '.swiper-scrollbar',
				hide: false
			}
		});
	}
}
